import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { renderDocsPreview } from '../../utils/docsPreviewConfig';

export default function DocsPreviewImage({ postId, className, alt = 'Article preview' }) {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        const dataUrl = renderDocsPreview(postId);
        setSrc(dataUrl);
    }, [postId]);

    if (!src) {
        return (
            <Box
                className={className}
                sx={{ bgcolor: '#111', border: '1px solid #333', flexShrink: 0 }}
                aria-hidden
            />
        );
    }

    return <img src={src} alt={alt} className={className} />;
}
